import React from 'react'

const ProductComparisonComponent = (props) => {
    const { Renderer } = props

    return <Renderer {...props} />
}

export default ProductComparisonComponent
